import { ReactElement } from "react";
import { Routes, Route } from "react-router-dom";

import { PATH_TO_REGISTER } from "constants/navigation";

import WelcomeAppFrame from "appFrames/welcomeAppFrame/WelcomeAppFrame";
import ToggleMfaStepProvider from "providers/ToggleMfaStepProvider";

import NonProductionBanner from "global-components/nonProdBanner/NonProductionBanner";

import LoginOrRegister from "pages/loginOrRegister/loginOrRegister";
import Register from "pages/register/Register";
import { Page404 } from "pages";

import { getEnvironmentName } from "lib/environment";

const UserRegistrationApp = (): ReactElement => {
  const isNonProduction = getEnvironmentName() !== "production";

  return (
    <WelcomeAppFrame headerTitle="Account creation">
      <ToggleMfaStepProvider>
        <div aria-label="authentication-app-viewport">
          {isNonProduction && <NonProductionBanner />}

          <Routes>
            <Route path="/" element={<LoginOrRegister />} />
            <Route path={PATH_TO_REGISTER} element={<Register />} />
            <Route path="*" element={<Page404 />} />
          </Routes>
        </div>
      </ToggleMfaStepProvider>
    </WelcomeAppFrame>
  );
};

export default UserRegistrationApp;
